import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const HrisError = () => {
  const { formatMessage } = useIntl();

  return (
    <Box className='error-wrapper'>
      <WarningAmberIcon color='error' fontSize='large' />
      <Typography variant='h2'>
        {formatMessage({
          id: 'stepper.hris.error.title',
          defaultMessage: 'Something went wrong.',
        })}
      </Typography>
      <Typography variant='h5' fontSize={14} textAlign='center'>
        {formatMessage({
          id: 'stepper.hris.error.description',
          defaultMessage:
            'Unfortunately, we could not find your data in the HR database. Please contact your HR department or the person who sent you this link.',
        })}
      </Typography>
    </Box>
  );
};

export default HrisError;
